type TopWindowDecision = { type: 'continue' } | { type: 'refuse' }

interface TopWindowDecisionInput {
  // False during server rendering. SSR is disabled app-wide today, but whether
  // a page is framed can only be known in the browser, so the gate must never
  // decide anything without one.
  isClient: boolean
  // The page's own window. Taken as an argument so the decision is testable
  // without a real frame.
  win: Pick<Window, 'self' | 'top'>
}

/**
 * Decide whether a page that must never be framed may continue. Pure: the
 * middleware (~/middleware/require-top-window.ts) supplies the window and acts
 * on the verdict.
 *
 * Framed means "not the top window". Reading `window.top` across origins can
 * throw in some browsers, and a throw counts as framed: the gate fails closed.
 */
export function decideTopWindowAction(
  input: TopWindowDecisionInput,
): TopWindowDecision {
  if (!input.isClient) return { type: 'continue' }

  try {
    if (input.win.self === input.win.top) return { type: 'continue' }
  } catch {
    return { type: 'refuse' }
  }

  return { type: 'refuse' }
}
